import React, { useEffect, useState } from "react";
import CommonDrawer from "../drawer/CommonDrawer";
import { Box } from "@mui/material";
import Text from "../text/Text";
import CloseIcon from "@mui/icons-material/Close";
import { btc, denomination, sats, settings, showBalance } from "../messages";
import { ButtonToggle } from "../buttonToggle/ButtonToggle";
import { setShowBTCAmount } from "../../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { sessionService } from "redux-react-session";

function ToggleBalanceComponent({
  currency,
  currentSession,
  setCurrentSession,
  isDrawerOpen,
  setIsDrawerOpen,
}) {
  const dispatch = useDispatch();

  const [selectedDenomination, setSelectedDenomination] = useState();

  const showBtcAmount = useSelector((state) => state.common.showBtcAmount);

  const denominationContent = [
    { children: sats, value: sats },
    { children: btc, value: btc },
  ];

  const showBalanceContent = [
    { children: "Always", value: "always" },
    { children: "On tap", value: "onTap" },
  ];

  useEffect(() => {
    setSelectedDenomination(showBtcAmount ? btc : sats);
  }, [showBtcAmount]);

  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
  };

  const handleChangeShowBalanceType = async (value) => {
    const sessionToUpdate = {
      ...currentSession,
      onTap: value === "onTap",
    };
    currentSession && (await sessionService.saveSession(sessionToUpdate));
    setCurrentSession(sessionToUpdate);
  };

  const handleChangeSatsToBtc = async (value) => {
    if (currency === sats) {
      dispatch(setShowBTCAmount(value === btc));
      const sessionToUpdate = {
        ...currentSession,
        showBtcAmount: value === btc,
      };
      currentSession && (await sessionService.saveSession(sessionToUpdate));
      setCurrentSession(sessionToUpdate);
    }
  };

  const handleToggleChange = async (_e, type, value) => {
    if (type === "denomination") {
      setSelectedDenomination(value);
      handleChangeSatsToBtc(value);
    } else if (type === "balance") {
      handleChangeShowBalanceType(value);
    }
  };

  return (
    <CommonDrawer
      anchor="bottom"
      open={isDrawerOpen}
      onClose={handleCloseDrawer}
      className={"settings-drawer"}
    >
      <Box padding="24px 16px">
        <Box className="drawer-header flex-between">
          <Text className="default-text" size={20} font="bold" mb="20px">
            {settings}
          </Text>
          <CloseIcon
            sx={{
              color: "#848B9E",
              height: "24px",
              width: "24px",
              marginRight: "8px",
              cursor: "pointer",
            }}
            onClick={handleCloseDrawer}
          />
        </Box>
        <Box className="flex-between" mb="16px">
          {currency === sats && (
            <>
              <Text className="default-text" size={16} font="regular">
                {denomination}
              </Text>
              <ButtonToggle
                content={denominationContent}
                value={selectedDenomination}
                onChange={(e) =>
                  handleToggleChange(e, "denomination", e.target.value)
                }
                customClass="drawer-item"
              />
            </>
          )}
        </Box>
        <Box className="flex-between">
          <Text className="default-text" size={16} font="regular">
            {showBalance}
          </Text>
          <ButtonToggle
            content={showBalanceContent}
            value={currentSession?.onTap ? "onTap" : "always"}
            onChange={(e) => handleToggleChange(e, "balance", e.target.value)}
            customClass="drawer-item"
          />
        </Box>
      </Box>
    </CommonDrawer>
  );
}

export default ToggleBalanceComponent;
